/**
 * @generated SignedSource<<aa37ef8d21aa45fa9730c7635ea0f6d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileTalkDetailsFragment$data = {
  readonly isTalk: boolean;
  readonly isLive: any | null;
  readonly " $fragmentType": "userProfileTalkDetailsFragment";
};
export type userProfileTalkDetailsFragment$key = {
  readonly " $data"?: userProfileTalkDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileTalkDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userProfileTalkDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTalk",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLive",
      "storageKey": null
    }
  ],
  "type": "ClientDetails",
  "abstractKey": null
};

(node as any).hash = "246ade869ccba395c912ebe92b383934";

export default node;
